export const state = () => ({
  maintenance: false,
  maintenance_msg: 'Manutenção programada de 07/08 (sexta-feira), às 23h59, até 08/08 (sábado), às 03h00.',
})
